<template>
  <v-container fluid>
    <v-snackbar
      v-for="(msg, i) in successSnackbarContents"
      :key="`success-${i}`"
      v-model="snackbarStatus"
      :style="{'margin-bottom': calcMargin(i)}"
      timeout="2000"
      bottom
      color="success"
      outlined
      right
    >
      {{ msg }}
    </v-snackbar>
    <v-snackbar
      v-for="(msg, i) in errorSnackbarContents"
      :key="`error-${i}`"
      v-model="snackbarStatus"
      :style="{'margin-bottom': calcMargin(i)}"
      timeout="2000"
      bottom
      color="red"
      outlined
      right
    >
      {{ msg }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'SnackBar',
  data: () => ({
    snackbarStatus: false,
  }),
  computed: {
    activateSnackbar() {
      return this.$store.state.snackbar.status
    },

    /**
       * @desc get the data of the success message from the store
       * @returns {null}
       */
    successSnackbarContents() {
      return this.$store.state.snackbar.successSnackbarContents
    },
    /**
       * @desc get the data of error message from the store
       * @returns {null}
       */
    errorSnackbarContents() {
      return this.$store.state.snackbar.errorSnackbarContents
    }
  },
  watch:{
    /**
       * @desc if the snackbar content change the snackbar status will change to true
       */
    errorSnackbarContents() {
      this.snackbarStatus || (this.snackbarStatus = true)
    },

    /***
     * @desc update snackbar status based on the snackbar content
     */
    successSnackbarContents() {
      this.snackbarStatus || (this.snackbarStatus = true)
    }
  },
  /**
   * @desc to make sure if there is any snackbar content in successful stack, enable it to true
   * */
  created() {
    if(this.successSnackbarContents != null) {
      this.snackbarStatus = true
    }
  },
  methods: {
    /**
       * @desc function to calculate the margin of each message to prevent it from piled on each other
       * @param i
       * @returns {string}
       */
    calcMargin(i) {
      return (i*60) + 'px'
    },
  }
}
</script>

<style scoped>

</style>
